import { useState, useEffect } from "react";
import { X, Cookie } from "lucide-react";

const NOTICE_KEY = "rheumhub_session_notice_v1";

export function SessionNoticeBanner() {
  const [show, setShow] = useState(false);
  const isAdvicelineHub = typeof window !== "undefined" && window.location.hostname.includes("advicelinehub");
  const appName = isAdvicelineHub ? "Advice Line Hub" : "RheumHub";

  useEffect(() => {
    const dismissed = localStorage.getItem(NOTICE_KEY);
    if (!dismissed) setShow(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(NOTICE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="relative z-30 bg-slate-800 text-slate-200 text-xs px-4 py-2.5 flex items-center gap-3">
      <Cookie className="h-4 w-4 shrink-0 text-slate-400" />
      <p className="flex-1 leading-relaxed">
        {appName} uses secure session cookies for authentication, and localStorage to remember your role and preferences. No tracking cookies are used. We use a self-hosted, cookieless analytics tool (Umami) for page view counting only.{" "}
        <a href="/privacy" className="underline text-slate-300 hover:text-white">Privacy Policy</a>
      </p>
      <button
        onClick={dismiss}
        className="shrink-0 hover:text-white ml-2"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
